import { useEffect, useRef } from 'react';

const cards = [
  {
    icon: 'ri-hammer-line',
    label: '파손된 캡 파편',
    desc: '캡이 깨지면서 파편이 볼트 주변에 쌓임',
    color: 'bg-orange-50 border-orange-200',
    iconColor: 'text-orange-500',
    iconBg: 'bg-orange-100',
  },
  {
    icon: 'ri-virus-line',
    label: '손상된 볼트 헤드',
    desc: '노출된 볼트 헤드에 녹과 부식 발생',
    color: 'bg-red-50 border-red-200',
    iconColor: 'text-red-500',
    iconBg: 'bg-red-100',
  },
  {
    icon: 'ri-drop-fill',
    label: '볼트 축 주위의 틈',
    desc: '틈을 타고 빗물이 단열재 코어까지 침수',
    color: 'bg-sky-50 border-sky-200',
    iconColor: 'text-sky-500',
    iconBg: 'bg-sky-100',
  },
];

const FieldProblem02Section = () => {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
          }
        });
      },
      { threshold: 0.1 }
    );
    const els = sectionRef.current?.querySelectorAll('.anim');
    els?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-24 bg-white" ref={sectionRef}>
      <div className="max-w-6xl mx-auto px-6 lg:px-8">

        {/* 헤더 */}
        <div className="text-center mb-14 anim opacity-0 translate-y-6 transition-all duration-700">
          <span className="inline-flex items-center gap-2 bg-sky-100 text-sky-700 text-xs font-bold tracking-widest uppercase px-4 py-1.5 rounded-full border border-sky-200 mb-6">
            <i className="ri-drop-fill" />
            FIELD PROBLEM 02
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-[#1B2A4A] leading-tight mb-4 font-display">
            볼트 주변 누수 발생
          </h2>
          <p className="text-sky-600 font-semibold text-base">
            실리콘 접착력 상실로 인한 직접 침투
          </p>
        </div>

        {/* 3개 카드 */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {cards.map((card, i) => (
            <div
              key={i}
              className={`anim opacity-0 translate-y-6 transition-all duration-700 rounded-2xl border p-7 ${card.color}`}
              style={{ transitionDelay: `${i * 100 + 150}ms` }}
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-full ${card.iconBg} mb-5`}>
                <i className={`${card.icon} ${card.iconColor} text-xl`} />
              </div>
              <h3 className="text-[#1B2A4A] font-bold text-base mb-2">{card.label}</h3>
              <p className="text-[#666] text-sm leading-relaxed">{card.desc}</p>
            </div>
          ))}
        </div>

        {/* 하단 강조 텍스트 */}
        <div className="anim opacity-0 translate-y-6 transition-all duration-700 delay-500">
          <div className="flex items-start gap-4 bg-[#1B2A4A] text-white rounded-2xl px-8 py-6 max-w-3xl mx-auto">
            <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-drop-fill text-sky-400 text-2xl" />
            </div>
            <p className="text-white/90 text-sm md:text-base leading-relaxed">
              볼트 축을 타고 내려간 빗물이{' '}
              <strong className="text-sky-300">단열재까지 침투</strong>하여 누수가 발생됩니다.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default FieldProblem02Section;
